export default __webpack_public_path__ + "static/media/1.350f6788.png";